import client from '../request'

const getAll = `/plans`

const get = (id) => {
  return `/plans/${id}`
}

const create = (data) => {
  return client.post('/plans', data)
}

const update = (id, data) => {
  return client.put(`/plans/${id}`, data)
}

const getActivity = (id) => {
  return `/plans/${id}/activity`
}

const addActivity = (id, data) => {
  return client.post(`/plans/${id}/activity/add`, data)
}

const reorderActivity = (id, data) => {
  return client.post(`/plans/${id}/activity/reorder`, data)
}

const removeActivity = (id, planActivityId, data) => {
  return client.delete(`/plans/${id}/activity/${planActivityId}`, { data })
}

const addUser = (id, data) => {
  return client.post(`/plans/${id}/users/add`, data)
}

const removeUser = (id, userId) => {
  return client.delete(`/plans/${id}/users/${userId}`)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data?.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}
const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const remove = (id) => {
  return client.delete(`/plans/${id}`)
}

const PlanService = {
  getAll,
  get,
  create,
  update,
  getActivity,
  reorderActivity,
  addActivity,
  removeActivity,
  addUser,
  removeUser,
  toRow,
  remove,
  toPaginate
}

export default PlanService
